import React from 'react'
import { Link } from 'react-router-dom'
import { Card, CardActions, CardTitle, CardText } from 'material-ui-legacy/Card'
import Subheader from 'material-ui-legacy/Subheader'

import { niceCount } from '../../lib/formats.js'
import { getWindowHeight } from '../../lib/util.js'
import errors from '../../lib/errors.js'
import LinearLoader from '../UI/LinearLoader'
import DeleteButton from '../UI/DeleteButton'
import EditButton from '../UI/EditButton'
import CloseButton from '../UI/CloseButton'
import ErrorDialog from '../UI/ErrorDialog'

import Resource from '../../stores/resource'
const ServiceCategoryStore = Resource('service-categories')
const ProjectStore = Resource('projects')

class ProjectTypeCard extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      serviceCategories: [],
      projects: [],
      error: '',
      loading: true
    }

    // Data can be received either as projectType or itemData.
    this.projectType = this.props.projectType || this.props.itemData
  }

  componentWillMount() {
    const promises = [
      ServiceCategoryStore.findAll({ projectTypeId: this.projectType.id }),
      ProjectStore.findAll({ projectTypeId: this.projectType.id })
    ]

    Promise.all(promises)
      .then(results => {
        const [serviceCategoriesResult, projectsResult] = results
        this.setState({
          serviceCategories: serviceCategoriesResult.data,
          projects: projectsResult.data,
          loading: false
        })
      })
      .catch(error =>
        this.setState({ error: errors.unpack(error), loading: false })
      )
  }

  _closeErrorDialog = () => this.setState({ error: '' })

  render() {
    const {
      editCallback,
      deleteCallback,
      closeCallback,
      noHeightAdjust
    } = this.props
    const { loading, error, serviceCategories, projects } = this.state

    const {
      name,
      serviceCategoryCount,
      projectCount
    } = this.projectType.attributes

    const subtitle =
      `${niceCount(projectCount, 'project', 'projects')}, ` +
      `${niceCount(
        serviceCategoryCount,
        'service category',
        'service categories'
      )}`

    const cardStyle = noHeightAdjust
      ? {}
      : {
          overflowY: 'auto',
          maxHeight: `${getWindowHeight() - 500}px`
        }

    return (
      <Card style={cardStyle}>
        <CardTitle title={name} subtitle={subtitle} />

        {Boolean(serviceCategoryCount) && (
          <CardText>
            <Subheader>Related service categories:</Subheader>
            {loading && <LinearLoader />}
            <ul>
              {serviceCategories.map(serviceCategory => (
                <li key={serviceCategory.id}>
                  <Link to={`/service-categories/${serviceCategory.id}`}>
                    {serviceCategory.attributes.name}
                  </Link>
                </li>
              ))}
            </ul>
          </CardText>
        )}

        {Boolean(projectCount) && (
          <CardText>
            <Subheader>Related projects:</Subheader>
            {loading && <LinearLoader />}
            <ul>
              {projects.map(project => (
                <li key={project.id}>
                  <Link to={`/projects/${project.id}`}>
                    {project.attributes.name}
                  </Link>
                </li>
              ))}
            </ul>
          </CardText>
        )}

        <CardActions>
          {editCallback && <EditButton onTouchTap={editCallback} />}
          {deleteCallback && (
            <DeleteButton
              onTouchTap={deleteCallback}
              confirmMessage={
                <p>
                  Are you sure you want to delete <strong>{name}</strong>?
                  There's no undo.
                </p>
              }
            />
          )}
          {closeCallback && <CloseButton onTouchTap={closeCallback} />}
        </CardActions>

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}
        >
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </Card>
    )
  }
}

export default ProjectTypeCard



// WEBPACK FOOTER //
// ./src/components/ProjectTypes/ProjectTypeCard.jsx